import { useGetCurrentEmployee } from "#resources/hooks/integrations/auth/query";
import { useGetZendeskMessagingJwt } from "#resources/hooks/integrations/zendesk/query";
import { contextLevelFromUrl } from "#resources/helpers/url/url";
import { useStores } from "#stores/index";
import {
	closeZendeskChat,
	logoutZendesk,
	openZendeskChat,
	setZendeskAuthToken,
	setZendeskOpenIntent,
	ZENDESK_FIELD_IDS,
	ZendeskConversationField,
} from "#structure/providers/zendesk";

export function useZendeskSupport() {
	const { data: currentEmployee } = useGetCurrentEmployee({});
	const { placeStore, eventStore } = useStores();
	const contextLevel = contextLevelFromUrl();

	const { refetch } = useGetZendeskMessagingJwt(undefined, {
		enabled: false,
		retry: false,
	});

	const buildFields = (): ZendeskConversationField[] => {
		const fields: ZendeskConversationField[] = [
			{ id: ZENDESK_FIELD_IDS.userName, value: currentEmployee?.name ?? "" },
			{
				id: ZENDESK_FIELD_IDS.organizationId,
				value: currentEmployee?.organization.id ?? "",
			},
			{
				id: ZENDESK_FIELD_IDS.organizationName,
				value: currentEmployee?.organization.name ?? "",
			},
			{ id: ZENDESK_FIELD_IDS.source, value: "Dashboard" },
		];

		if (contextLevel === "place" || contextLevel === "event") {
			fields.push(
				{ id: ZENDESK_FIELD_IDS.placeId, value: placeStore.place?.id ?? "" },
				{ id: ZENDESK_FIELD_IDS.placeName, value: placeStore.place?.name ?? "" },
			);
		}

		if (contextLevel === "event") {
			fields.push(
				{ id: ZENDESK_FIELD_IDS.eventId, value: eventStore.event?.id ?? "" },
				{ id: ZENDESK_FIELD_IDS.eventName, value: eventStore.event?.name ?? "" },
			);
		}

		return fields;
	};

	const openSupport = async () => {
		setZendeskOpenIntent(true);
		let token: string | undefined;
		try {
			const result = await refetch();
			token = result.data;
		} catch {}
		if (token) setZendeskAuthToken(token);
		openZendeskChat(buildFields());
	};

	const closeSupport = () => {
		closeZendeskChat();
		logoutZendesk();
	};

	return { openSupport, closeSupport };
}
